<template>
  <div class="image-list">
    <div :style="{display:'inline-block',position:'relative'}" v-for="(item,index) in renderList" :key="index">
    <z-image
      :class="{'mask':overflow && index == 2}"
      :src="item"
      fit="cover"
      @click="handlePreview(index)"
    >
    </z-image>
    <span class="fix-content" v-if="overflow && index == 2">{{`+${infoList.length-3}`}}</span>
    </div>
  </div>
</template>
<script>
import { Image, ImagePreview } from '@zz-common/zz-ui';
import Vue from 'vue'
Vue.use(ImagePreview);
export default {
  name: 'ImageList',
  props: ['infoList'],
  data() {
    return {
      previewInstance: null
    }
  },
  computed: {
    //超过三个隐藏，加样式
    overflow() {
      return this.infoList.length > 3
    },
    renderList() {
      return this.infoList.slice(0, 3)
    }
  },
  components: {
    'z-image': Image
  },
  methods: {
    handlePreview(index) {
      ImagePreview({
        images: this.infoList,
        startPosition: index
      });
    }
  }

}
</script>
<style lang="less" scoped>
 @import 'index.less';
</style>